module.exports = __webpack_public_path__ + "src/img/reporter-l.6de1d524.svg";